import { useState, useEffect } from 'react'
import './card-overlay.scss'
// hooks
import useScroll from '../../../../hooks/useScroll'

const CardOverlay = props => {
	const { img, headerContent, children } = props

	// hooks
	const { scrollPosition } = useScroll({
		positionTop: 0
	})

	// data
	const [currentPosition, setCurrentPosition] = useState(50)
	const [isLastPosition, setIsLastPosition] = useState(window.scrollY)
	const [isOpen, setIsOpen] = useState(false)

	// actions
	const openSection = () => {
		setCurrentPosition(20)
		setIsOpen(true)
	}

	const detectPosition = position => {
		if (!isOpen) return setIsOpen(true)
		position > isLastPosition ? setCurrentPosition(20) : setCurrentPosition(50)
		setIsLastPosition(position)
	}

	useEffect(() => {
		detectPosition(scrollPosition)
		return () => setIsOpen(false)
	}, [scrollPosition])

	return (
		<section className='m-card-overlay'>
			<div
				className='m-card-overlay__head'
				style={{ backgroundImage: `url(${img})`, height: `${currentPosition}vh` }}
			>
				{headerContent}
			</div>
			<div
				className='m-card-overlay__body'
				style={{
					marginTop: `calc(${currentPosition}vh - 10px) `,
					height: `${100 - currentPosition}vh`
				}}
				onClick={() => openSection()}
			>
				<div className='container pb0' style={{ position: 'relative' }}>
					<div className='m-card-overlay__mark__button'>
						<span className='m-card-overlay__mark' />
					</div>
				</div>
				{children}
			</div>
		</section>
	)
}

export default CardOverlay
